import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api/assessment`;

const err = (e) => {
  const d = e?.response?.data?.detail;
  return new Error(typeof d === "string" ? d : e?.message || "Request failed");
};

export const getQuestions = async () => {
  try {
    const { data } = await axios.get(`${API}/questions`);
    return data;
  } catch (e) {
    throw err(e);
  }
};

export const analyzeAssessment = async (answers) => {
  try {
    const { data } = await axios.post(`${API}/analyze`, { answers });
    return data;
  } catch (e) {
    throw err(e);
  }
};

export const unlockReport = async (submissionId, email) => {
  try {
    const { data } = await axios.post(`${API}/unlock`, { submissionId, email });
    return data;
  } catch (e) {
    throw err(e);
  }
};
